export default __webpack_public_path__ + "static/media/StartupStudio.0b4c8566.svg";